import { consumeGenerator } from '@baidu/icloud-generator';
export function generatorLatest(func) {
  let lastetTaskId = 0;
  let canceled = false;
  return async (...arr) => {
    const res = func(...arr);
    const next = res === null || res === void 0 ? void 0 : res.next;

    if (typeof next !== 'function') {
      return res;
    }

    await consumeGenerator(func(...arr), {
      isExecutable: currentTaskId => {
        return !canceled && currentTaskId === lastetTaskId;
      },
      onStart: () => {
        canceled = false;
        lastetTaskId++;
        return lastetTaskId;
      }
    });
  };
}
//# sourceMappingURL=es/Form/extendsEffects/utils/generatorLatest.js.map